module.exports = __webpack_public_path__ + "img/arrow-down-right-circle.3d71e5b4.svg";